<ng-container *ngIf="this.activeSearchTab === 'content'">
    <pcg-ng-content-search (searchTabChange)="switchSearchTab($event)" [activeSearchTab]="this.activeSearchTab" [searchTabConfig]="getTabConfig('content')"></pcg-ng-content-search>
</ng-container>

<ng-container *ngIf="this.activeSearchTab  === 'directory'">
    <pcg-ng-directory-search (searchTabChange)="switchSearchTab($event)" [activeSearchTab]="this.activeSearchTab" [searchTabConfig]="getTabConfig('directory')"></pcg-ng-directory-search>
</ng-container>

